import React, { useMemo, useState, useEffect } from "react";
import TableContainer from '../../components/Common/TableContainer';
import { getVisionType } from "service/api";
import { toast } from "react-toastify";

const Vision_type_list = ({ refresh }) => {
  const [visionTypes, setVisionTypes] = useState([]);

  useEffect(() => {
    fetchVisionTypes();
  }, [refresh]);

  const fetchVisionTypes = async () => {
    try {
      const response = await getVisionType();
      if (Array.isArray(response?.data)) {
        setVisionTypes(response.data);
      } else {
        setVisionTypes([]);
      }
    } catch (error) {
      toast.error("Error fetching vision types");
      console.error("Fetch error:", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Vision",
        accessor: "vision.vision",
        Cell: ({ value }) => <strong>{value || "—"}</strong>,
      },
      {
        Header: "Sub-Type",
        accessor: "sub_type",
        Cell: ({ value }) => (
          <span style={{
            background: value === "Stock" ? "#e8f5e9" : "#e3f2fd",
            color: value === "Stock" ? "#2e7d32" : "#1565c0",
            padding: "2px 10px",
            borderRadius: 12,
            fontWeight: 600,
            fontSize: 12,
          }}>
            {value || "—"}
          </span>
        ),
      },
      {
        Header: "UC (R)",
        accessor: "uc",
        Cell: ({ value }) => value ? `R ${value}` : "—",
      },
      {
        Header: "HC (R)",
        accessor: "hc",
        Cell: ({ value }) => value ? `R ${value}` : "—",
      },
      {
        Header: "HMC Blue (R)",
        accessor: "hmc_blue",
        Cell: ({ value }) => value ? `R ${value}` : "—",
      },
      {
        Header: "SHMC Blue (R)",
        accessor: "shmc_blue",
        Cell: ({ value }) => value ? `R ${value}` : "—",
      },
      {
        Header: "Photo (R)",
        accessor: "photo",
        Cell: ({ value }) => value ? `R ${value}` : "—",
      },
    ],
    []
  );

  document.title = "Vision Type | List";

  return (
    <div className="container-fluid mt-3">
      <TableContainer
        columns={columns}
        data={visionTypes}
        isGlobalFilter={true}
        isAddOptions={false}
        customPageSize={20}
        className="custom-header-css"
      />
    </div>
  );
};

export default Vision_type_list;
